import apiClient, { setToken, clearToken, getToken } from './client'

export default {
  /**
   * Redirect to backend OAuth login endpoint
   */
  login() {
    const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1'
    window.location.href = `${baseURL}/auth/login`
  },

  /**
   * Handle OAuth callback - store JWT token
   * @param {string} token - JWT token from OAuth callback
   */
  handleCallback(token) {
    if (token) {
      setToken(token)
      return true
    }
    return false
  },

  /**
   * Logout - clear JWT token
   */
  logout() {
    clearToken()
  },

  /**
   * Get current authenticated user profile
   * @returns {Promise<Object>} User profile data
   */
  async getMe() {
    const response = await apiClient.get('/users/me')
    return response.data
  },

  /**
   * Check if user is authenticated (has valid token)
   * @returns {boolean}
   */
  isAuthenticated() {
    return !!getToken()
  },

  /**
   * Get stored JWT token
   * @returns {string|null}
   */
  getStoredToken() {
    return getToken()
  }
}
